import { apiRequest } from '../helpers'

export async function getAnrede() {
  const response = await apiRequest(`${process.env.REACT_APP_API_URL}/stammdaten/anrede`, 'GET')

  return response
}

export async function getLegalForms() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/legal-forms`,
    'GET'
  )

  return response.legalForms
}

export async function getEuVatIdCountryCode() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/eu-vat-id-country-code`,
    'GET'
  )

  return response
}

export async function getFederalState() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/federal-state`,
    'GET'
  )

  return response
}

export async function getRegisterEntry() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/register-entry`,
    'GET'
  )

  return response
}

export async function getAddressType() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/address-type`,
    'GET'
  )

  return response
}

export async function getShippingSuplement() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/shipping-suplement`,
    'GET'
  )

  return response
}

export async function getAbbrevSalutation() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/abbrev-salutation`,
    'GET'
  )

  return response
}

export async function getAdelstitel() {
  const response = await apiRequest(`${process.env.REACT_APP_API_URL}/stammdaten/adelstitel`, 'GET')

  return response
}

export async function getNamePrefix() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/name-prefix`,
    'GET'
  )

  return response
}

export async function getRelationshipName() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/relationship`,
    'GET'
  )

  return response
}

export async function getBanks(filter: string) {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/banks/${filter}`,
    'GET'
  )

  return response
}

export async function getBanksByCountry(countryCode: string) {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/banks/${countryCode}`,
    'GET'
  )

  return response.banks || []
}

export async function getTaxAuthoritiesByCountry(countryCode: string) {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/tax-authorities/${countryCode}`,
    'GET'
  )

  return response.taxAuthorities || []
}
